export default __webpack_public_path__ + "static/media/gallery_02.bc983b36.jpg";